<template>
  <a-cascader :class="klass"
              :options="list"
              :changeOnSelect='changeOnSelect'
              :value="value"
              :disabled="disabled"
               @change="onChange" :placeholder="placeholder"

  />
</template>

<script>

import eBase from '@/base/eBase.js';
import _ from 'underscore';

export default {

  props: {
    url: { required: true },
    method: { required: false, default: 'get' },
    klass: { required: false, default: 'full-input' },
    placeholder: { required: false, default: '请选择' },
    value: { required: false, default() { return []; } },
    disabled: { required: false, default: false },
    changeOnSelect:{required:false,default:false},
  },

  data() {
    return {
      list: [],
    };
  },

  mounted() {
    eBase.debug('[DynamicCascader.vue][mounted][enter]');
    this.init();
  },

  watch: {
    value: {
      handler(newValue, oldValue) {
      },
      immediate: false,
    },
  },

  computed: {
  },

  methods: {

    init() {
      this.search();
    },

    search() {
      const self = this;
      eBase.send({ url: this.url, params: {} }, this.method).then((res) => {
        self.list = res.data.list || res.data.data;
      }, (res) => {
        eBase.debug('[DynamicCascader.vue][search][erro]' + JSON.stringify(res));
      });
    },

    onChange(value) {
      this.$emit('change', value);
    },

  }, // EOF methods
};
</script>



// WEBPACK FOOTER //
// src/components/select/DynamicCascader.vue